export const INITIAL_STATE = {
  appointments: null,
  appointmentsSelected: null,

  scheduleAppointmentLoading: false,
  scheduleAppointmentSuccess: null,
  scheduleAppointmentFailure: null,

  scheduleQuickAppointmentLoading: false,
  scheduleQuickAppointmentSuccess: null,
  scheduleQuickAppointmentFailure: null,

  getAllAppointmentsLoading: false,
  getAllAppointmentsSuccess: null,
  getAllAppointmentsFailure: null,

  getAppointmentLoading: false,
  getAppointmentSuccess: null,
  getAppointmentFailure: null,

  rescheduleAppointmentLoading: false,
  rescheduleAppointmentSuccess: null,
  rescheduleAppointmentFailure: null,

  cancelAppointmentLoading: false,
  cancelAppointmentSuccess: null,
  cancelAppointmentFailure: null,

  newDonorBonusEligibilitySuccessLoading: false,
  newDonorBonusEligibilitySuccess: null,
  newDonorBonusEligibilityFailure: null,
  
  updateGiftCardPreferenceLoading: false,
  updateGiftCardPreferenceSuccess: null,
  updateGiftCardPreferenceFailure: null
}
